import*as t from"react";import{defaultTheme as e}from"@aws-amplify/ui";const o=t.createContext({theme:e});export{o as AmplifyContext};
//# sourceMappingURL=AmplifyContext.js.map
